module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0755.3db55503.jpg";